import { ApplicationController } from '@aha-app/mvc';
import ExtensionContribution from 'components/framework/models/ExtensionContribution';

class CommandsController extends ApplicationController {
  static PHASE_LOADING = 0;
  static PHASE_CHOOSE_COMMAND = 1;
  static PHASE_EXECUTE_COMMAND = 2;

  static initialState = {
    // List of available commands.
    allCommands: [],
    // Current phase of the state machine.
    phase: CommandsController.PHASE_LOADING,
  };

  async initialize({ query, initialCommand, initialCommandArgs, callback }) {
    this.state.phase = CommandsController.PHASE_LOADING;
    this.state.allCommands = await ExtensionContribution.select(
      'id',
      'name',
      'identifier'
    )
      .where({ contributes: 'commands' })
      .all();
    this.changeProps({ query });
    this.state.phase = CommandsController.PHASE_CHOOSE_COMMAND;

    if (initialCommand) {
      const command = this.state.allCommands.find(
        c => c.identifier === initialCommand
      );
      if (command) {
        this.actionChooseCommand(command, initialCommandArgs, callback);
      } else {
        console.error(`Command '${initialCommand}' not found`);
      }
    }
  }

  async changeProps({ query }) {
    this.state.commands = this.state.allCommands.filter(c =>
      c.name.toLowerCase().includes(query.toLowerCase())
    );
  }

  async actionChooseCommand(command, args = {}, callback) {
    const result = await this.parent.commandController.actionExecuteCommand(
      command,
      args
    );
    if (callback) callback(result);
  }
}

export default CommandsController;
